import InventoryManufacturerModel from '../../models/Inventory/InventoryManufacturerModel';
import BaseStore from '../BaseStore';

class InventoryManufacturerStore extends BaseStore {
  constructor(transportLayer) {
    super(InventoryManufacturerModel, transportLayer);
  }
}

export default InventoryManufacturerStore;



// WEBPACK FOOTER //
// ./src/stores/Inventory/InventoryPcategoryStore.js